import React from 'react';
import './SchedulingCalendar.css';

export interface Appointment {
    id: number;
    customer_name: string;
    customer_phone: string;
    professional: number;
    professional_name?: string;
    service: number;
    service_name?: string;
    start_time: string;
    end_time: string;
    status: 'PENDING' | 'CONFIRMED' | 'COMPLETED' | 'CANCELLED';
}

interface AppointmentCardProps {
    appointment: Appointment;
    onClick: (appointment: Appointment) => void;
    style?: React.CSSProperties;
    showProfessional?: boolean; // Useful for week view where columns are days
}

const AppointmentCard: React.FC<AppointmentCardProps> = ({
    appointment,
    onClick,
    style,
    showProfessional = false
}) => {
    const startDate = new Date(appointment.start_time);
    const endDate = new Date(appointment.end_time);

    const formatTime = (date: Date) => {
        return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    };

    const getStatusClass = (status: string) => {
        switch (status) {
            case 'CONFIRMED': return 'status-confirmed';
            case 'COMPLETED': return 'status-completed';
            case 'CANCELLED': return 'status-cancelled';
            default: return 'status-pending';
        }
    };

    return (
        <div
            className={`appointment-card ${getStatusClass(appointment.status)}`}
            style={style}
            onClick={(e) => {
                e.stopPropagation();
                onClick(appointment);
            }}
            title={`${appointment.customer_name} - ${appointment.service_name || 'Serviço'}`}
        >
            <div className="appointment-time">
                {formatTime(startDate)} - {formatTime(endDate)}
            </div>

            {showProfessional && appointment.professional_name && (
                <div className="fw-bold text-warning mb-1" style={{ fontSize: '0.8rem' }}>
                    {appointment.professional_name.toUpperCase()}
                </div>
            )}

            <div className="appointment-title">
                {appointment.customer_name} - <span style={{ fontWeight: 'normal', opacity: 0.9 }}>{appointment.service_name || 'Serviço'}</span>
            </div>
        </div>
    );
};

export default AppointmentCard;
